import "@/App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Services } from "@/components/landing/Services";
import { Manifesto } from "@/components/landing/Manifesto";
import { Stats } from "@/components/landing/Stats";
import { Testimonials } from "@/components/landing/Testimonials";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { ProcessServing } from "@/pages/ProcessServing";

function Home({ navigate }) {
  return (
    <>
      <Hero onNavigate={navigate} />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <Stats />
      <Testimonials />
      <Contact />
    </>
  );
}

function Shell() {
  const lenis = useLenis();
  const location = useLocation();
  const routerNavigate = useNavigate();

  // Scroll to top on route change
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, lenis]);

  const navigate = (href) => {
    // Full route
    if (href.startsWith("/")) {
      routerNavigate(href);
      return;
    }
    // Hash — if on home, scroll; otherwise navigate home then scroll
    if (href === "#top") {
      if (location.pathname !== "/") routerNavigate("/");
      lenis?.scrollTo(0, { duration: 1.2 });
      return;
    }
    const doScroll = () => {
      const el = document.querySelector(href);
      if (el) lenis?.scrollTo(el, { offset: -60, duration: 1.2 });
    };
    // If the target exists on the current page, scroll in place.
    if (document.querySelector(href)) {
      doScroll();
      return;
    }
    // Target not on current page → route home then scroll after render.
    routerNavigate("/");
    setTimeout(doScroll, 350);
  };

  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid="landing-root">
      <div className="grain" aria-hidden="true" />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0C",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F8F9FA",
          },
        }}
      />
      <Header onNavigate={navigate} currentPath={location.pathname} />
      <main>
        <Routes>
          <Route path="/" element={<Home navigate={navigate} />} />
          <Route path="/process-serving" element={<ProcessServing onNavigate={navigate} />} />
        </Routes>
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <Shell />
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
